var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"m-icon",style:(`line-height: ${_vm.size}px`)},[_c('span',{staticClass:"material-icons",class:{'cursor-pointer': _vm.pointer},style:(`font-size: ${_vm.size}px; width: ${_vm.size}px; color: ${_vm.color} `)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }